export default "__VITE_ASSET__DQFPO9FW__"